import React, { useReducer, useState, useEffect } from "react";
import { Link } from "react-router-dom";
import axios from "axios";
import { GlobalSet } from '../../global/GlobalProvider';
import loading_img from "../../../../images/profile/loading.gif";
import { Dropdown, Button, Modal } from "react-bootstrap";
import { SRLWrapper } from "simple-react-lightbox";
import { useTranslation } from 'react-i18next';

const initialState = false;
const reducer = (state, action) => {
  switch (action.type) {
    case 'sendMessageOpen':
      return { ...state, sendMessage: true };
    case 'sendMessageClose':
      return { ...state, sendMessage: false };
    default:
      return state;
  }
};

const PostDetails = () => {
  const { t } = useTranslation();
  const { BaseUrl } = GlobalSet();
  const [loading, setLoading] = useState(true);
  const [getway, setGetway] = useState([]);
  const [state, dispatch] = useReducer(reducer, initialState);

  const options = {
    settings: {
      overlayColor: "#000000",
    },
  };

  useEffect(() => {
    const data = {
      key_s: 'eyJ0eXAiOiJKV1Qidfg%!#%$%LCdf#*&*JhbGciOiJSUzI1NiJ9',
    };
    axios.post('/apps-deposit', data)
      .then(response => {
        setGetway(response.data.data);
        setLoading(false);
      })
      .catch(error => {
        console.log(error);
      });
  }, []);

  return (
    <div className="container py-4">
      <div className="row">
        {getway.map((getwayitem) => (
          <div key={getwayitem.id} className="col-lg-12 mb-4">
            <div className="card shadow-xl border-0">
              <div className="card-header bg-info d-flex justify-content-between align-items-center p-3 rounded-top">
                <h5 className="text-white mb-0">{getwayitem.payment_type}</h5>
                <img src={BaseUrl + getwayitem.photo} alt="" className="rounded" width={80} height={40} />
              </div>

              <div className="row g-3 p-4">
                {getwayitem.allmatch.map((element) => (
                  <div key={element.id} className="col-xl-4 col-lg-4 col-md-6 col-sm-12">
                    <Link
                      to={
                        element.ap_type === 'local'
                          ? `local-deposit-view/${element.id}/${element.slug}`
                          : element.ap_type === 'newpayment'
                          ? `crypto-deposit-view/${element.id}/${element.slug}`
                          : "casino-providers"
                      }
                      className="text-decoration-none"
                    >
                      <div className="card h-100 text-center hover-shadow border-0">
                        <div className="card-body d-flex flex-column align-items-center">
                          <img src={BaseUrl + element.photo} alt="" className="img-fluid mb-3" style={{ maxHeight: "80px" }} />
                          <h6 className="bg-success text-white px-2 py-1 rounded small mt-auto">{element.sort_discription}</h6>
                        </div>
                      </div>
                    </Link>
                  </div>
                ))}
              </div>

            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default PostDetails;
